import React from "react"
import { useFormContext } from "react-hook-form"

import Form from "src/components/Form"

import { SPACE_TYPES } from "../constants"

const SpaceTypeSelector = () => {
  const { register } = useFormContext()

  return (
    <div data-testid="stw-space-type-select">
      <Form.Label htmlFor="space-type">Preferred Space Type</Form.Label>
      <Form.Select id="space-type" {...register("space_type")}>
        {SPACE_TYPES.map(({ name, value }) => (
          <option key={value} value={value}>
            {name}
          </option>
        ))}
      </Form.Select>
    </div>
  )
}

export default SpaceTypeSelector
